import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
const RSVPs = {
    state: () => ({
        items: [],
        detailedFilter: false,
        timeout: null,
        registrationInputs: [],
        selectedRegistrationInputs: [],
        showRegistrationInputs: false,
        filter: {
            searchTerm: null,
            skip: 0,
            take: 20,
            total: 0,
            page: 1,
            tagID: null,
            status: null,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setRSVPs(state, payload) {
            state.items = payload.items;

            state.filter.total = payload.total;
        },
        setRegistrationInputs(state, payload) {
            state.registrationInputs = payload.items;

            state.registrationInputs.map((item) => {
                if (state.selectedRegistrationInputs.some((k) => k == item.id) && item.isActive == false) {
                    var index = state.selectedRegistrationInputs.findIndex((k) => k == item.id);
                    state.selectedRegistrationInputs.splice(index, 1);
                }
            });

            setTimeout(() => {
                localStorage.getItem('rInputs', JSON.stringify(state.selectedRegistrationInputs));
            }, 50);
        },
        setSelectedRSVPs(state, payload) {
            state.selectedItems = payload;
        },
        setRSVPPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getRSVPs');
        },
        setRSVPTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getRSVPs');
        },
    },
    actions: {
        async getRSVPs(store) {
            clearTimeout(store.state.timeout);

            store.state.timeout = setTimeout(async() => {
                store.state.loading = true;
                await axios
                    .post('invitation/load', {
                        ...store.state.filter,
                        skip: (store.state.filter.page - 1) * store.state.filter.take,
                    })
                    .then((res) => {
                        store.state.loading = false;
                        return store.commit('setRSVPs', res.data.data);
                    });
            }, 25);
        },
        async toggleRSVP(store, payload) {
            var res = await axios.post('RSVP/toggleisblocked', {
                id: store.state.items[payload.index].id,
            });

            return res.data;
        },
        async deleteRSVP(store, payload) {
            await axios
                .post('invitation/delete', {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit('setRSVPPage', store.state.filter.page - 1);
                        }
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
        //TODO RSVP Check-In
        async rsvpcheckIn(store, payload) {
            await axios
                .post('invitation/checkin', {
                    id: payload.id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        payload.context.$message.success(res.data.alert.message);
                        store.dispatch('getRSVPs');
                    }
                });
        },
    },
    getters: {},
};
export default RSVPs;


// WEBPACK FOOTER //
// ./src/store/rsvp.js